import { endOfWeek, startOfWeek, today, yesterday } from "@utils/date";

import type { DateRange } from "rsuite/DateRangePicker";

type PredefinedRange = { label: string; value: DateRange };

export const predefinedRanges: PredefinedRange[] = [
  {
    label: "Today",
    value: [new Date(today), new Date(today)],
  },
  {
    label: "Yesterday",
    value: [new Date(yesterday), new Date(yesterday)],
  },
  {
    label: "This week",
    value: [new Date(startOfWeek), new Date(endOfWeek)],
  },
];
